import { Injectable } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Preferences } from '@capacitor/preferences'; import { Router } from '@angular/router';
import { BadgeService } from 'src/app/services/badge.service'; import { AuthService } from 'src/app/services/auth.service';
import { BadgeCountService } from 'src/app/services/badge-count.service';
import { Capacitor } from '@capacitor/core'; import { PedidosService } from 'src/app/services/pedidos.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class PushService {
  // 🔹 Vai emitir eventos sempre que chegar um novo push
  private newPushSubject = new BehaviorSubject<any | null>(null);
  newPush$ = this.newPushSubject.asObservable();

  constructor(
    private badgeService: BadgeService, 
    private pedidosService: PedidosService, 
    private badgeCountService: BadgeCountService,
    private router: Router, 
    private authService: AuthService) {
    console.log('[Capacitor] referenced in PushService');
    }

  async initPushNotifications(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;

    const permStatus = await PushNotifications.requestPermissions();
    if (permStatus.receive !== 'granted') {
      console.warn('[PushService] Permissão negada para push.');
      return;
    }

    try {
      await PushNotifications.register();
    } catch (err) {
      console.error('Erro ao registrar PushNotifications:', err);
    }

    PushNotifications.addListener('registration', async (token) => {
      console.log('[PushService] FCM token atual:', token.value);
    
      const storedTokenResult = await Preferences.get({ key: 'fcm_token' });
      const storedToken = storedTokenResult.value;
    
      if (storedToken !== token.value) {
        console.log('[PushService] Novo token detectado');
    
        // Salva localmente
        await Preferences.set({
          key: 'fcm_token',
          value: token.value,
        });
    
        // Se usuário estiver logado, já atualiza no backend
        const userId = localStorage.getItem('user_id');
        if (userId) {
          this.authService.checkAndUpdateDeviceToken().subscribe({
            next: () => console.log('✅ Token atualizado no backend'),
            error: (err) => console.error('❌ Erro ao atualizar token no backend', err)
          });
        }
      } else {
        console.log('[PushService] Token não mudou, nada a fazer');
      }
    });


    PushNotifications.addListener('registrationError', (error) => {
      console.error('[PushService] Erro ao registrar push:', error);
    });

    PushNotifications.addListener('pushNotificationReceived', async (notification) => {
      console.log('[PushService] Push recebido (app aberto):', notification);

      // 📢 Emite o push para qualquer componente que esteja ouvindo
      this.newPushSubject.next(notification);

      // Se o backend mandou a contagem no payload (ex: data.unreadCount)
      const unreadCount = notification.data?.unreadCount;
      if (unreadCount !== undefined) {
        await this.badgeCountService.setUnreadPushCount(Number(unreadCount));
      }
    });

    PushNotifications.addListener('pushNotificationActionPerformed', async (notification) => {
      console.log('[PushService] Interagiu com o push:', notification);

      try {
        const userIdStr = localStorage.getItem('user_id');
        const pushIdStr = notification.notification?.data?.push_notification_id;

        // Converte para número
        const userId = userIdStr ? Number(userIdStr) : null;
        const pushId = pushIdStr ? Number(pushIdStr) : null;
        const route = notification.notification?.data?.route;


        if (userId && pushId) {
          // Chama seu service para marcar como lido
          this.pedidosService.markPushAsRead(userId, pushId).subscribe({
            next: async () => {
              console.log('✅ Push marcado como lido no backend');

              // Atualiza contador interno
              const novoValor = Math.max(0, this.pedidosService.getCurrentUnreadPushCount() - 1);
              this.pedidosService.setUnreadPushCount(novoValor);

              // Atualiza badge
              if (novoValor === 0) {
                await this.badgeCountService.clearPushBadge();
              } else {
                await this.badgeCountService.setUnreadPushCount(novoValor);
              }

              // 📍 Navegação se veio rota no push
              if (route) {
                console.log('[PushService] Navegando para:', route);
                this.router.navigate([route]);
              }
            },
            error: (err) => {
              console.error('❌ Erro ao marcar notificação como lida:', err);
            }
          });
        } else {
          console.warn('[PushService] Sem user_id ou push_notification_id para marcar como lido');
        }
      } catch (err) {
        console.error('[PushService] Erro ao processar ação do push:', err);
      }
    });

  }

  async getStoredToken(): Promise<string | null> {
    const result = await Preferences.get({ key: 'fcm_token' });
    return result.value;
  }
}

